import { Dispatch, SetStateAction, useCallback } from 'react'

import { useManagedTimers } from './useManagedTimers'

export const useFieldsErrorAnimation = <T extends object>(setFieldsError: Dispatch<SetStateAction<T>>) => {
    const { setManagedInterval, setManagedTimeout, clearManagedInterval } = useManagedTimers()

    return useCallback((field: keyof T) => {
        const intervalID = setManagedInterval(() => {
            setFieldsError((prevState) => ({
                ...(prevState as object),
                [field]: !(prevState as Record<string, boolean | undefined>)[field as string],
            } as T))
        }, 400)

        setManagedTimeout(() => {
            setFieldsError((prevState) => ({
                ...prevState,
                [field]: false,
            } as T))

            clearManagedInterval(intervalID)
        }, 8000)
    }, [clearManagedInterval, setFieldsError, setManagedInterval, setManagedTimeout])
}